"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SceneLayouts = exports.SINGLE = exports.SIDE_BY_SIDE = exports.SCREEN_PRESENTER_LIMIT = exports.SCENE_WIDTH = exports.SCENE_HEIGHT = exports.SCENE_ASPECT_RATIO = exports.GRID = exports.FEATURED_SCREEN = exports.FEATURED_PRESENTER = exports.FEATURED_MEDIA = exports.CAMERA_PRESENTER_LIMIT = exports.ALL_LAYOUTS = void 0;
var _resources = require("./resources");
var sceneLayoutGrid = _resources.resources.sceneLayoutGrid,
  sceneLayoutSideBySide = _resources.resources.sceneLayoutSideBySide,
  sceneLayoutSingle = _resources.resources.sceneLayoutSingle,
  sceneLayoutFeaturedScreen = _resources.resources.sceneLayoutFeaturedScreen,
  sceneLayoutFeaturedMedia = _resources.resources.sceneLayoutFeaturedMedia,
  sceneLayoutFeaturedPresenter = _resources.resources.sceneLayoutFeaturedPresenter;
var SINGLE = exports.SINGLE = {
  id: 'SINGLE',
  title: 'Single',
  thumbnail: sceneLayoutSingle
};
var SIDE_BY_SIDE = exports.SIDE_BY_SIDE = {
  id: 'SIDE_BY_SIDE',
  title: 'Side by Side',
  thumbnail: sceneLayoutSideBySide
};
var GRID = exports.GRID = {
  id: 'GRID',
  title: 'Grid',
  thumbnail: sceneLayoutGrid
};
var FEATURED_SCREEN = exports.FEATURED_SCREEN = {
  id: 'FEATURED_SCREEN',
  title: 'Featured Screen',
  thumbnail: sceneLayoutFeaturedScreen
};
var FEATURED_MEDIA = exports.FEATURED_MEDIA = {
  id: 'FEATURED_MEDIA',
  title: 'Featured Media',
  thumbnail: sceneLayoutFeaturedMedia
};
var FEATURED_PRESENTER = exports.FEATURED_PRESENTER = {
  id: 'FEATURED_PRESENTER',
  title: 'Featured Presenter',
  thumbnail: sceneLayoutFeaturedPresenter
};
var SCREEN_PRESENTER_LIMIT = exports.SCREEN_PRESENTER_LIMIT = 2;
var CAMERA_PRESENTER_LIMIT = exports.CAMERA_PRESENTER_LIMIT = 10;
var SceneLayouts = exports.SceneLayouts = [SINGLE, SIDE_BY_SIDE, GRID, FEATURED_PRESENTER, FEATURED_SCREEN, FEATURED_MEDIA];
var ALL_LAYOUTS = exports.ALL_LAYOUTS = [SINGLE, SIDE_BY_SIDE, GRID, FEATURED_PRESENTER, FEATURED_SCREEN, FEATURED_MEDIA];
var SCENE_WIDTH = exports.SCENE_WIDTH = 1920;
var SCENE_ASPECT_RATIO = exports.SCENE_ASPECT_RATIO = 16 / 9;
var SCENE_HEIGHT = exports.SCENE_HEIGHT = SCENE_WIDTH / SCENE_ASPECT_RATIO;